import { PerformanceCyclesCycleSelectFieldDocument } from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import Selector from 'modules/core/components/Selector'
import { useQuery } from 'modules/core/hooks/useQuery'

export const CycleSelectField: React.FC<{
  label?: string
  blankLabel: string
  placeholder: string
  value?: string | null
  error?: string
  onChange: (value: string | null) => void
  isDisabled?: boolean
}> = ({ label, blankLabel, placeholder, value, onChange, error, isDisabled = false }) => {
  const { data, loading } = useQuery(PerformanceCyclesCycleSelectFieldDocument)
  const cycles = sortBy(data?.performanceCycles.cycles ?? [], ['title'])

  return (
    <Selector.Popover
      isDisabled={isDisabled}
      label={label}
      blankLabel={blankLabel}
      placeholder={placeholder}
      loading={loading}
      error={error}
      value={value ? [value] : []}
      onChange={(ids) => {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        onChange(ids as string | null)
      }}
    >
      {cycles.map((cycle) => (
        <Selector.Option
          key={cycle.id}
          value={cycle.id.toString()}
          label={cycle.title}
          searchValue={cycle.title}
        >
          {cycle.title}
        </Selector.Option>
      ))}
    </Selector.Popover>
  )
}
